import {
  Snackbar,
  Tab,
  Tabs,
  Box,
  TextField,
  MenuItem,
  Menu,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import Notification from "../common/Notification";
import UserMenu from "../common/UserMenu";
import { useHistory } from "react-router-dom";
import AuthContext from "../../store/auth-context";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { teleconsulationService } from "../../services/teleconsult.service";
import moment from "moment";
import { patientService } from "../../services/patient.service";

const TeleAppointment = () => {
  const authCtx = useContext(AuthContext);
  const history = useHistory();
  const [t] = useTranslation();

  const [upcomingAppt, setUpcomingAppts] = useState<any>([]);

  const [familyMemberList, setFamilyMemberList] = useState<any>([]);
  const [familyMemberId, setFamilyMemberId] = useState<any>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("error");
  const [accessToken, setAccessToken] = useState<string>("");
  const [globalObject, setGlbalObject] = useState<any>("");
  const [patientIdHISList, setPatientIdHISList] = useState<any>([]);

  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  const baseUrlForTele = process.env.REACT_APP_TELECONSULT_BASEURL;
  const pastThresholdTime: any = process.env.REACT_APP_AFTER_THRESHOLD_MINUTE;

  const handleModelClose = () => setShowModal(false);

  useEffect(() => {
    const getFamilyList = () => {
      fetchFamilyMember();
    };
    getFamilyList();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const getpatient = () => {
      getPatientRecord();
    };

    getpatient();
  }, [familyMemberId]);

  const getPatientRecord = async () => {
    authCtx.toggleLoader(true);
    let idList;
    setPatientIdHISList([]);
    setIsLoading(true);
    const patientRecord = JSON.parse(
      localStorage.getItem("getPatientRecord") || "{}"
    );
    const isPatientRecordCall = localStorage.getItem("isPatientRecordCall");

    if (
      Object.keys(patientRecord).length !== 0 &&
      patientRecord[0].patientId[0] !== "" &&
      isPatientRecordCall === "true" &&
      familyMemberId === 0 &&
      userData.facilityId
    ) {
      await callingSSOLoginAPI(patientRecord);
    } else {
      let res = await patientService.getPatientRec(
        userData.userId,
        familyMemberId,
        userData.facilityId
      );
      if (res && res.data === undefined) {
        idList = [];
        console.log("Somthing went wrong in response");
      } else {
        idList = res.data;

        idList &&
          idList.forEach((item: any) => {
            if (
              item &&
              (item.patientId !== null ||
                (item.mobileNo && item.mobileNo !== ""))
            ) {
              if (patientIdHISList.length > 0) {
                if (patientIdHISList.some((obj: any) => obj.his === item.his)) {
                  patientIdHISList.forEach((item2: any) => {
                    if (
                      item2.his === item.his &&
                      item2.patientId !== item.patientId
                    ) {
                      item2.patientId = [...item2.patientId, item.patientId];
                    }
                  });
                } else {
                  let data = {
                    his: item.his,
                    patientId: [item.patientId],
                    mobileNo: item.mobileNo,
                  };
                  patientIdHISList.push(data);
                }
              } else {
                let data = {
                  his: item.his,
                  patientId: [item.patientId],
                  mobileNo: item.mobileNo,
                };
                patientIdHISList.push(data);
              }
            }
          });

        if (patientIdHISList.length > 0) {
          await callingSSOLoginAPI(patientIdHISList);
        } else {
          setModalType("error");
          setModalText(t("Error in get patient records"));
          setShowModal(true);
        }
        //setPatientIdList(idList);
      }
    }
    authCtx.toggleLoader(false);
  };

  const callingSSOLoginAPI = async (patientRecord: any) => {
    authCtx.toggleLoader(true);
    const APPID: any = process.env.REACT_APP_TELECONSULT_APPID_BURJEEL;
    try {
      const data = {
        familyMemberId: familyMemberId,
        PatientMrn: patientRecord[0].patientId[0],
      };
      const res = await teleconsulationService.TeleSSOLogin(data);
      if (res && res.message.status === "Success" && res.data) {
        const authorization: any = res.data.access_token;
        const user_id = res.data.patientProfile.user_id;
        const patient_profile_id = res.data.patientProfile.id;

        const globalObject = {
          baseURL: baseUrlForTele + "/web/api/",

          APPID: APPID,

          Authorization: authorization,

          patient_profile_id: patient_profile_id,

          user_id: user_id,

          font_color: " #000000",

          subfont_color: "#00008b",

          font_size: "18px",

          font_family: " Arial, sans-serif",

          primary_color: "#8b0548",

          secondary_color: "#4E525B",
        };
        setGlbalObject(globalObject);
        setAccessToken(authorization);
        getConsultationList(globalObject);
      } else {
        setModalType("error");
        setModalText(t("Something went wrong!"));
        setShowModal(true);
      }
    } catch (error: any) {
      setModalType("error");
      setModalText(t("Something went wrong!"));
      setShowModal(true);
    }
    authCtx.toggleLoader(false);
  };

  const getConsultationList = async (globalObject: any) => {
    authCtx.toggleLoader(true);
    setIsLoading(true);
    const postData = {
      patientId: globalObject.user_id,
      token: globalObject.Authorization,
      today: "yes",
    };
    try {
      const res: any = await teleconsulationService.ConsultationList(postData);
      if (res && res.message.status === "Success" && res.data) {
        setUpcomingAppts(res.data);
      } else {
        setModalType("error");
        setModalText(t("Something went wrong!"));
        setShowModal(true);
      }
    } catch (e: any) {
      setModalType("error");
      setModalText(t("Something went wrong!"));
      setShowModal(true);
    }
    setIsLoading(false);
    authCtx.toggleLoader(false);
  };

  const fetchFamilyMember = async () => {
    const familyMembers = JSON.parse(
      localStorage.getItem("familyMemberList") || "[]"
    );
    setFamilyMemberList(familyMembers);
  };

  const handleFamilyChange = (e: any) => {
    if (e.target.value === 0) {
      setFamilyMemberId(0);
    } else {
      setFamilyMemberId(Number(e.target.value));
    }
  };

  const handleStartConsultation = (item: any) => {
    const beforeThresholdTime = process.env.REACT_APP_BEFORE_THRESHOLD_MINUTE;
    const currentDate: any = new Date().toISOString().slice(0, 10);
    const appointmentDate: any = item.consultData.date
      ? item.consultData.date
          .split("-")
          .reverse()
          .toString()
          .replaceAll(",", "-")
      : "";

    const timeDiff = diff_minutes(appointmentDate, item.consultData.time);
    if (currentDate === appointmentDate) {
      // if (timeDiff <= Number(beforeThresholdTime)) {
      const consultData: any = item.consultData;
      const redirectUrl =
        baseUrlForTele +
        "/src/camcheck.php?id=" +
        consultData.id +
        "&meeting_id=" +
        consultData.meeting_id +
        "&doctor_id=" +
        consultData.doctor_id +
        "&patient_id=" +
        consultData.patient_id +
        "&patient_profile_id=" +
        consultData.patient_profile_id +
        "&access_token=" +
        accessToken +
        "&globals=" +
        encodeURIComponent(JSON.stringify(globalObject));
      window.location.replace(redirectUrl);
      // } else {
      //   setModalText(
      //     t(
      //       "You can start teleconsultation before 5 minute of your appointment time"
      //     )
      //   );
      //   setModalType("error");
      //   setShowModal(true);
      // }
    } else {
      setModalText(
        t("Your teleconsultation appointment is scheduled on") +
          " " +
          appointmentDate
      );
      setModalType("error");
      setShowModal(true);
    }
  };

  const handlePayment = (item: any) => {
    const paymentLink = item.payment_link ? item.payment_link : "";
    if (paymentLink) {
      window.location.replace(paymentLink);
    } else {
      setModalText(t("No Payment Link Found"));
      setModalType("error");
      setShowModal(true);
    }
  };

  const openMobileMenu = (e: any) => {
    e.preventDefault();

    document.getElementById("leftMenu")?.classList.remove("d-none");
  };

  function diff_minutes(date: any, time: any) {
    const time24 = moment(time, ["h:mm A"]).format("HH:mm:ss");
    const aaptTime = new Date(date + " " + time24).getTime();
    const aaptTime_minute = Math.floor(Math.floor(aaptTime / 1000) / 60);
    const currentTime = new Date().getTime();
    const currentTime_minute =
      Math.floor(Math.floor(currentTime / 1000) / 60) - 90;
    var diff = aaptTime_minute - currentTime_minute;

    return diff;
  }

  return (
    <>
      <div className="main-content animate py-4 px-3 px-sm-1">
        <div className="d-flex align-items-center mb-3">
          <a
            href="#"
            className="d-inline-block d-sm-none text-dark"
            onClick={(e) => openMobileMenu(e)}
          >
            <i className="material-icons-outlined me-2">menu</i>
          </a>
          <h3 className="fs-18-24">{t("Teleconsultation Appointments")}</h3>
          <div
            className={`${
              authCtx.selectedLanguage === "en" ? "ms-auto" : "mr-auto"
            } mw-90px`}
          >
            <Notification />
            <UserMenu />
          </div>
        </div>
        <div className="card-body p-1 mt-1">
          <div className="card border-0 shadow-sm">
            <div className="card-body py-0 px-0 position-relative">
              <div className="gx-3 row m-0 px-2 border-bottom">
                <div className={`col-sm-4 col-lg-3 ms-auto my-3`}>
                  <div className="form-floating">
                    <TextField
                      required
                      select
                      id="Choose Patient"
                      label={t("Choose Patient")}
                      className="w-100 bg-white"
                      variant="outlined"
                      size="small"
                      value={familyMemberId}
                      onChange={(e) => handleFamilyChange(e)}
                    >
                      <MenuItem value={0}>
                        {userData.firstName} {userData.lastName}
                      </MenuItem>
                      {familyMemberList &&
                        familyMemberList.map((item: any) => (
                          <MenuItem
                            value={item.familyMemberId}
                            key={item.familyMemberId}
                          >
                            {item.firstName} {item.lastName} ({item.relation})
                          </MenuItem>
                        ))}
                    </TextField>
                  </div>
                </div>
              </div>

              {upcomingAppt && upcomingAppt.length > 0 ? (
                <div className="container-fluid">
                  <div className="row align-items-center d-none d-lg-flex">
                    <div className="col-lg-3 p-3 fw-600">{t("Doctor")}</div>
                    <div className="col-lg-3 p-3 fw-600">{t("Patient")}</div>
                    <div className="col-lg-3 p-3 fw-600">{t("Status")}</div>
                    <div className="col-lg-3 p-3 fw-600">{t("Action")}</div>
                  </div>

                  {upcomingAppt &&
                    upcomingAppt.map((item: any, index: any) => (
                      <>
                        <div
                          className="row border-top align-items-center"
                          key={"upAppt" + index}
                        >
                          <div className="col-lg-3 col-sm-6 p-3">
                            <div className="d-flex">
                              <div className="flex-grow-1 mt-2 text-truncate ln-normal">
                                <label className="fw-bold text-truncate w-100">
                                  {item.doctorUser.name}
                                </label>

                                <p className="text-muted fs-12 m-0 text-truncate w-100 mt-1">
                                  {t("General Practitioner")}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 col-sm-6 px-3 pt-sm-3 pb-3">
                            <label className="fw-bold">
                              {item.consultData.patient_name}
                            </label>
                            <p
                              className={`text-muted fs-12 mb-0 mt-1 ${
                                authCtx.selectedLanguage === "en"
                                  ? ""
                                  : "text-start"
                              }`}
                              dir="ltr"
                            >
                              {item.consultData.time}&nbsp;|&nbsp;
                              {item.consultData.date &&
                                new Date(
                                  item.consultData.date
                                    .split("-")
                                    .reverse()
                                    .toString()
                                    .replaceAll(",", "-")
                                ).toDateString()}
                            </p>
                          </div>
                          <div className="col-lg-3 col-sm-6 px-3 py-sm-3">
                            {item.consultData.appointment_status ===
                            "Consultation Completed" ? (
                              <span className="px-3 py-2 rounded-3 bg-success bg-opacity-10 text-success fw-600">
                                {t("Consultation Completed")}
                              </span>
                            ) : item.consultData.appointment_payment_status ===
                              "Payment Completed" ? (
                              <span className="px-3 py-2 rounded-3 bg-success bg-opacity-10 text-success fw-600">
                                {t("Payment Completed")}
                              </span>
                            ) : item.consultData.appointment_payment_status ===
                              "Payment Pending" ? (
                              <span className="px-3 py-2 rounded-3 bg-warning bg-opacity-10 text-warning fw-600">
                                {t("Payment Pending")}
                              </span>
                            ) : (
                              <span className="px-3 py-2 rounded-3 light-bg text-primary fw-600">
                                {item.consultData.appointment_status ===
                                "Appointment Booked"
                                  ? t("Booked")
                                  : item.consultData.appointment_status === null
                                  ? t("Booked")
                                  : item.consultData.appointment_status}
                              </span>
                            )}
                          </div>
                          <div className="col-lg-3 col-sm-6 p-3">
                            <div className="d-flex">
                              <button
                                className="btn btn-primary no-focus me-2"
                                onClick={(e) => handleStartConsultation(item)}
                                disabled={
                                  item.consultData
                                    .appointment_payment_status ===
                                  "Payment Pending"
                                    ? true
                                    : item.consultData.appointment_status ===
                                      "Consultation Completed"
                                    ? true
                                    : item.consultData
                                        .appointment_payment_status ===
                                      "Payment Not Required"
                                    ? false
                                    : item.consultData
                                        .appointment_payment_status ===
                                      "Payment Completed"
                                    ? false
                                    : true
                                }
                              >
                                {/* <i className="fa-solid fa-video me-2"></i> */}
                                {t("Consultation")}
                              </button>
                              <button
                                className="btn btn-outline-primary no-focus"
                                onClick={(e) => handlePayment(item)}
                                disabled={
                                  item.consultData
                                    .appointment_payment_status !==
                                  "Payment Pending"
                                }
                              >
                                {/* <i className="fa-solid fa-dollar-sign me-2"></i> */}
                                {t("Payment")}
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                </div>
              ) : isLoading ? (
                <p className="fw-11 text-center text-secondary position-relative top-50 p-5">
                  {t("Please wait! Loading Appointments")}
                </p>
              ) : (
                <>
                  <p className="fw-11 text-center text-secondary position-relative top-50 p-5">
                    {t("No Upcoming Appointment Found")}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {modalType === "error" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleModelClose}
        >
          <Alert onClose={handleModelClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
      {modalType === "success" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleModelClose}
        >
          <Alert onClose={handleModelClose} severity="success">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default TeleAppointment;
